import { render } from "./PortfolioPreview.vue?vue&type=template&id=f0b0a2da&ts=true"
import script from "./PortfolioPreview.vue?vue&type=script&lang=ts"
export * from "./PortfolioPreview.vue?vue&type=script&lang=ts"

import "./PortfolioPreview.vue?vue&type=style&index=0&id=f0b0a2da&lang=scss"

import exportComponent from "/builds/saatsazov/saatsazov-com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__